import { hasOwnership } from '../../utils/user'
import { useLoggedInUser } from './useLoggedInUser'

export function useIsOwner(): boolean {
  const user = useLoggedInUser()
  return !!hasOwnership(user)
}
